import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArrayStringValue from '../objects/internationalizedArrayStringValue.js';
var id = 'internationalizedArrayString';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArrayStringValue'
        }
    ]
};
var validator = z.array(internationalizedArrayStringValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayString.js.map